import styled from "styled-components";

const PageWrapper = styled.div`
  //max-height: 100vh;
  height: 100%;
  width: 100%;
`;
export default PageWrapper;
